import styled from 'styled-components'

export const PageContainer = styled.div`
  width: 95%;
  max-width: 1200px;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  margin: auto;
`

export const ImageContainer = styled.div`
  width: 50%;
  align-self: center;
`

export const Image = styled.img`
  width: 100%;
  height: auto;
`
export const TextContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;
`

export const Text = styled.p`
  font-size: 1.2rem;
  text-align: center;
  width: 90%;
`
